import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions, alertActions } from '_actions';
import ReactDatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { getDateMDYYYY } from '_helpers';
import styles from './DBDateField.module.css'

class DBDateField extends React.Component {



    handleValueChange(date) {
        let minDate = this.props.minDate ? new Date(this.props.minDate) : new Date('1900/01/01');
        let maxDate = this.props.maxDate ? new Date(this.props.maxDate) : new Date('2100/01/01');

        if (date === null) {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
        }
        else if (date instanceof Date === false) {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            this.props.alertWarning('The date value was invalid.');
        }
        else if (date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()) {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            let customMsg = this.props.customMsg ? this.props.customMsg : undefined;
            if (!customMsg) {
                if (minDate.getTime() === new Date('1900/01/01').getTime() && maxDate.getTime() !== new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(maxDate) + ' or earlier.';
                }
                else if (minDate.getTime() !== new Date('1900/01/01').getTime() && maxDate.getTime() === new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(minDate) + ' or after.';
                }
                else {
                    customMsg = '  The date must be in the range of 1/1/1900 to 1/1/2100.';
                }
                customMsg = 'The date was not in the valid range.' + customMsg;
            }

            this.props.alertWarning(customMsg);
        }
        else {
            this.props.updateDateField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, date);
        }
        if (!this.props.disabled && this.props.handleValueChange) {
            this.props.handleValueChange(date);
        }
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <span className={styles.icon}>
                    <FontAwesomeIcon icon={faCalendarAlt} style={{ zIndex: -999 }} />
                </span>
                <ReactDatePicker
                    className={this.props.disabled ? styles.picker_disabled : this.props.required ? styles.picker_required : styles.picker}
                    selected={this.props.value}
                    onChange={(date) => this.handleValueChange(date)}
                    placeholderText='m/d/yyyy'
                    dateFormat='M/d/yyyy'
                    todayButton='Today'
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateDateField: bindActionCreators(noteActions.updateDateField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}



function mapStateToProps(state, ownprops) {
    let value = state.entities.notes[ownprops.entity]
        && state.entities.notes[ownprops.entity][ownprops.entityKeyValue]
        && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null
        ?
        new Date(state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field])
        : ''

    return {
        value: value
    };

}

const connectedDBDateField = connect(mapStateToProps, mapDispatchToProps)(DBDateField);
export { connectedDBDateField as DBDateField };